<app-nav></app-nav>

<main class="support-page">
  <!-- ─── Hero ─────────────────────────────────────────────────────── -->
  <section class="support-hero brand-section">
    <div class="hero-orb hero-orb-blue"></div>
    <div class="hero-orb hero-orb-green"></div>

    <div class="support-hero-inner">
      <span class="brand-eyebrow">Help center</span>
      <h1>How can we help?</h1>
      <p class="brand-lede">
        Quick answers to the questions we hear most. If you don't see what
        you need, our team is one message away.
      </p>
    </div>
  </section>

  <!-- ─── FAQ ──────────────────────────────────────────────────────── -->
  <section id="faq" class="faq brand-section">
    <div class="section-header">
      <span class="brand-eyebrow">Frequently asked</span>
      <h2>The questions we hear most.</h2>
    </div>

    <div class="faq-list">
      @for (faq of faqs; track faq.question; let i = $index) {
        <div class="faq-item" [class.is-open]="openFaq === i">
          <button
            type="button"
            class="faq-question"
            (click)="toggleFaq(i)"
            [attr.aria-expanded]="openFaq === i"
            [attr.aria-controls]="'faq-panel-' + i"
          >
            <span>{{ faq.question }}</span>
            <mat-icon class="faq-chevron">expand_more</mat-icon>
          </button>
          <div
            class="faq-answer-wrap"
            [id]="'faq-panel-' + i"
            role="region"
            [attr.aria-hidden]="openFaq !== i"
          >
            <div class="faq-answer-inner">
              <div class="faq-answer">
                <p>{{ faq.answer }}</p>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </section>

  <!-- ─── Still need help ──────────────────────────────────────────── -->
  <section class="support-cta brand-section">
    <div class="support-cta-inner">
      <span class="brand-eyebrow">Still stuck?</span>
      <h2>Send us a note — we read every message.</h2>
      <p class="brand-lede">
        For account-specific issues, bug reports, or anything not covered
        above, the contact form is the fastest way to reach the team.
      </p>
      <div class="support-cta-actions">
        <a class="brand-btn brand-btn-primary brand-btn-large" routerLink="/contact">
          <mat-icon>email</mat-icon>
          Contact us
        </a>
        <a class="brand-btn brand-btn-ghost" href="mailto:support@stml.app">
          support&#64;stml.app
        </a>
      </div>
    </div>
  </section>
</main>

<app-footer></app-footer>
